<template>
  <div class="impresso">
    <div class="cabecalho">
      <img
        :src="require('../../assets/brasao-pms.png')"
        alt="Logo prefeitura"
        class="logo"
      />
      <div class="titulo">
        <h1>PREFEITURA DE SANTOS</h1>
        <h2>Abono de falta - Lei Nº 4.623/84</h2>
      </div>
      <div class="via">
        <b>{{ `${via}ª VIA` }}</b>
        {{ ` - ${destino}` }}
      </div>
    </div>
    <div class="data-cabecalho">
      <div class="nesta">NESTA</div>
      <div class="data">
        Santos,
        <span v-if="mostraSolicitada">
          <date-picker
            class="form-control data-texto"
            name="dataSolicitacao"
            id="dataSolicitacao"
            :config="config"
            v-model="dataSolicitacao"
          ></date-picker>
        </span>
        <span v-else>{{ dataSolicitacao | extenso }}</span>
      </div>
    </div>
    <div class="corpo">
      {{ nomeServidor }}, registro nº {{ servidor.registroFormatado }}, ocupante
      do(a) {{ servidor.cargoPrincipal }}, lotado(a) na
      {{ servidor.siglaUnidadeOrganizacional }}, faltará no serviço no dia
      <span v-if="mostraFalta">
        <date-picker
          class="form-control data-texto"
          name="dataFalta"
          id="dataFalta"
          :config="config"
          v-model="dataFalta"
        ></date-picker>
      </span>
      <span v-else>{{ dataFalta | extenso }}</span>
      , vindo pelo presente solicitar o ABONO da falta, de acordo com a lei nº
      4.623/84, de 12 de junho de 1984.
    </div>
    <div class="despacho">
      DESPACHO: _________________________________
      <br />____________________________________________ <br />Em
      _________/_________/_____________
    </div>
    <div class="assinaturas">
      <div class="funcionario">
        <div class="linha">___________________________________________</div>
        <div class="inscricao">Assinatura do funcionário</div>
      </div>
      <div class="chefe">
        <div class="linha">VISTO: ____________________________________</div>
        <div class="inscricao">
          (Assinatura e carimbo)
          <br />CHEFE DA UNIDADE
        </div>
      </div>
    </div>
    <div class="rodape">COSUPRI - SEAD/029</div>
  </div>
</template>

<script>
import Botao from '@/components/botao';
import moment from 'moment';
moment.locale('pt-BR');

export default {
  name: 'FaltaLei',
  components: {
    Botao,
  },
  data() {
    return {
      dataSolicitacao: this.dataSolicitada,
      dataFalta: this.dataDaFalta,
      mostraSolicitada: this.mostraDataSolicitada,
      mostraFalta: this.mostraDataFalta,
      config: {
        format: 'L',
        useCurrent: false,
        locale: 'pt-br',
      },
    };
  },
  props: {
    via: {
      type: String,
      required: true,
    },
    destino: {
      type: String,
      required: true,
    },
    nomeServidor: {
      type: String,
      required: true,
    },
    servidor: {
      type: Object,
      required: true,
    },
    dataSolicitada: {
      type: [Date, String],
      required: false,
    },
    dataDaFalta: {
      type: [Date, String],
      required: false,
    },
    mostraDataSolicitada: {
      type: Boolean,
      required: true,
    },
    mostraDataFalta: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    entraDataSolicitada() {
      const solicitacao = this.trataObjetoOuString(this.dataSolicitacao);
      this.$emit('getDataSolicitada', solicitacao);
    },
    entraDataFalta() {
      const falta = this.trataObjetoOuString(this.dataFalta);
      this.$emit('getDataFalta', falta);
    },
    trataObjetoOuString(data) {
      return typeof data === 'object'
        ? moment(data).format('DD/MM/YYYY')
        : data;
    },
    limpaDataSolicitada() {
      this.dataSolicitacao = new Date();
    },
    limpaDataFalta() {
      this.dataFalta = new Date();
    },
  },
  filters: {
    extenso(data) {
      return moment(data, 'DD/MM/YYYY').format('LL');
    },
  },
  created() {
    this.$parent.$on('enviaDatas', () => {
      this.entraDataSolicitada();
      this.entraDataFalta();
    });
  },
};
</script>

<style src="./estilo.css" scoped />



// WEBPACK FOOTER //
// impresso.vue?70e67aa6